"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = getBlogpostCollectDependencies;
function getBlogpostCollectDependencies() {
  return {};
}


//////////////////
// WEBPACK FOOTER
// ./~/@bd/bdcore-data/build/Blogposts/filters/getBlogpostCollectDependencies.js
// module id = 832
// module chunks = 0